const BottomSheet = () => null;

export default BottomSheet;
